import type { Module } from 'vuex';
import { state } from './state';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import type { IContentState } from '@/store/modules/content/types';
import type { RootState } from '@/store/types';

const namespaced: boolean = true;

export const contentModule: Module<IContentState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
